import { Injectable } from "@angular/core"
import { AngularFirestoreCollection } from "@angular/fire/firestore"

import { IncompleteTest } from "@tr/models"
import { FirebaseCollectionBase } from "./firebase-resource-base"
import { FirebaseService } from "./firebase.service"

@Injectable({
  providedIn: "root",
})
export class IncompleteTestService extends FirebaseCollectionBase<IncompleteTest> {
  public getId = (item: IncompleteTest) => item._id
  constructor(fb: FirebaseService) {
    super(fb)
  }

  public getCollection(company: string, project: string, internal: boolean): AngularFirestoreCollection<IncompleteTest> {
    let incompleteTestsCollection: AngularFirestoreCollection<IncompleteTest>
    if (internal) {
      incompleteTestsCollection = this.firebaseService
        .collection("companies")
        .doc(company)
        .collection("projects")
        .doc(project)
        .collection<IncompleteTest>("IncompleteTests")
    } else {
      incompleteTestsCollection = this.firebaseService.collection<IncompleteTest>("IncompleteTests")
    }

    return incompleteTestsCollection
  }

  public async getData(company, project, internal): Promise<IncompleteTest[]> {
    let snapshot
    if (internal) {
      snapshot = await this.getCollection(company, project, internal)
        .ref.where("project", "==", project)
        .get()
    } else {
      snapshot = await this.getCollection(company, project, internal)
        .ref.get()
    }

    this.data = this.snapshotToData(snapshot)
    return this.data
  }

  public snapshotToData(snapshot): IncompleteTest[] {
    return snapshot.empty
      ? []
      : snapshot.docs.map(doc => {
        const incompleteTest = doc.data() as IncompleteTest
        incompleteTest._id = doc.id
        this.dataMap[doc.id] = incompleteTest
        return incompleteTest
      })
  }

  public async update(
    company: string,
    project: string,
    incompleteId: string,
    testToUpdate: any,
    internal: boolean,
  ): Promise<void> {
    return this.getCollection(company, project, internal)
      .doc(incompleteId)
      .update(testToUpdate)
  }
}

export function incompleteTestsMatch(item, test): boolean {
  return (
    item.company === test.company &&
    item.runId.toString() === test.runId.toString() &&
    item.testId === test.testId &&
    item.platform === test.platform &&
    item.isPhysicalDevice === test.isPhysicalDevice &&
    item.osVersion === test.osVersion &&
    item.environment === test.environment
  )
}
